if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        if (this.submitButton)
          this.add_to_cart_label =
            this.submitButton.querySelector(".add_to_cart_label");
      }
      // const originallabel = this.add_to_cart_label.textContent;

      onSubmitHandler(evt) {
        evt.preventDefault();
        console.log("form is being handle");
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );
        console.log('logging this',this)

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        console.log(
          "from product",
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              const buttonLabel = this.submitButton.querySelector(
                ".product-add-to-cart-btn-text"
              );
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");

              this.querySelector(
                "#product-add-to-cart-btn-text"
              ).classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
            var textChange =
              this.add_to_cart_label.getAttribute("data-textChange");
            if (this.add_to_cart_label ) {
              const orignallabel = this.add_to_cart_label.textContent;
              this.add_to_cart_label.textContent = "Added";
              this.submitButton.disabled = true;
              const nextButton = this.submitButton.nextElementSibling;
              if (nextButton.tagName === "BUTTON") {
                nextButton.classList.remove("hide-field");
              }
              console.log('add to cart label',orignallabel)
              setTimeout(() => {
                // console.log('original labe is',originallabel)
                this.add_to_cart_label.textContent = "BUY"
                this.submitButton.disabled = false;
              }, 1000);
              const selectElement = this.form.querySelector("select");
              if (selectElement) {
                const varaintId = nextButton.getAttribute("data-variant-id");
                if (varaintId) {
                  const optionElement = selectElement.querySelector(
                    `option[value='` + varaintId + `']`
                  );
                  optionElement.setAttribute("data-added", "yes");
                }
              }
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
